function gcd(a, b) {
    a = Math.abs(a);
    b = Math.abs(b);
    while (b !== 0) {
      [a, b] = [b, a % b];
    }
    return a || 1;
  }

function getQuestionPool(topic) {
    switch (topic) {
      case "exponentsRadicals":
        return [
          // Q1) Exponential Growth: Social Media
          {
            question: () => {
              // random daily multiplier 2..5
              const multiplier = Math.floor(Math.random() * 4) + 2;
              // initial participants 1..3
              const initial = Math.floor(Math.random() * 3) + 1;
              // target day 3..5
              const targetDay = Math.floor(Math.random() * 3) + 3;
              const total = initial * Math.pow(multiplier, targetDay - 1);
  
              const qHtml = `
                <p><strong>Scenario:</strong> You’re organizing a social-media challenge. Each day,
                the number of participants multiplies by <strong>${multiplier}</strong>. On Day&nbsp;1,
                there are <strong>${initial}</strong> participant${initial>1?'s':''}.</p>
                <p><strong>Question:</strong> On Day&nbsp;${targetDay}, how many participants will
                there be (assuming the pattern continues)? </p>
              `;
              return {
                q: qHtml,
                a: String(total),
                distract: [
                  String(total + multiplier),
                  String(Math.pow(multiplier, targetDay)) // ignoring initial
                ]
              };
            }
          },
  
          // Q2) Data Compression / Dividing Powers
          {
            question: () => {
              // file size 2^x, x in [8..12]
              const x = Math.floor(Math.random() * 5) + 8;
              // compress factor 2^y, y in [2..4]
              const y = Math.floor(Math.random() * 3) + 2;
              const newExp = x - y;
  
              const qHtml = `
                <p><strong>Scenario:</strong> A data file is <code>2^${x}</code> kilobytes.
                A compression tool reduces the file size by a factor of <code>2^${y}</code>.</p>
                <p><strong>Question:</strong> What is the new file size (in kilobytes), expressed
                as a power of 2? </p>
              `;
              return {
                q: qHtml,
                a: `2^${newExp}`,
                distract: [
                  `2^${x + y}`,
                  `2^${Math.abs(x - 2*y)}`
                ]
              };
            }
          },
  
          // Q3) Negative Exponent: Cost Halving
          {
            question: () => {
              const costNow = Math.floor(Math.random() * 20) + 30; // $30..$49
              const years = Math.floor(Math.random() * 3) + 1;     // 1..3
              // final cost => costNow * (1/2)^years
              const finalCost = costNow * Math.pow(0.5, years);
  
              const qHtml = `
                <p><strong>Scenario:</strong> A gadget costs <strong>$${costNow}</strong> this year.
                Each year, the price is cut in half (i.e., multiplied by 1/2).</p>
                <p><strong>Question:</strong> After <strong>${years}</strong> year${years>1?'s':''},
                how much does the gadget cost? </p>
              `;
              return {
                q: qHtml,
                a: `$${finalCost.toFixed(2)}`,
                distract: [
                  `$${(costNow / years).toFixed(2)}`,
                  `$${(costNow * 2).toFixed(2)}`
                ]
              };
            }
          },
  
          // Q4) Diagonal of a square tile
          {
            question: () => {
              const side = Math.floor(Math.random() * 8) + 3; // side 3..10
              const diag = `${side}√2`;
  
              const qHtml = `
                <p><strong>Scenario:</strong> You’re designing a square-tile patio. Each tile side
                is <strong>${side} cm</strong>.</p>
                <p><strong>Question:</strong> What is the diagonal length of one tile? Give your
                answer in simplified radical form.</p>
              `;
              return {
                q: qHtml,
                a: `${diag} cm`,
                distract: [
                  `√${2 * side * side} cm`,
                  `${side * 2} cm`
                ]
              };
            }
          },
  
          // Q5) Fractional Exponent: Area -> Side
          {
            question: () => {
              // pick from perfect squares [36,49,64,81,100]
              const squares = [16, 25, 36, 49, 64, 81, 100];
              const area = squares[Math.floor(Math.random() * squares.length)];
              const side = Math.sqrt(area);
  
              const qHtml = `
                <p><strong>Scenario:</strong> A square has an area of <strong>${area} m²</strong>.</p>
                <p><strong>Question:</strong> What is the side length? Express it using a radical or
                fractional exponent</p>
              `;
              return {
                q: qHtml,
                a: `${side}`,
                distract: [
                  String(side + 1),
                  (side - 1 > 0 ? String(side - 1) : String(side + 2))
                ]
              };
            }
          }
        ];
  
  
      /* -----------------------------------------------------------
         2) Polynomial Operations
      ----------------------------------------------------------- */
      case "polynomialOperations":
        return [
          // Q1) Add polynomials: combining two shipments
          {
              question: () => {
                // fixed coefficients for clarity
                const A1 = 5, B1 = 3, C1 = 4;
                const A2 = 4, B2 = 2, C2 = 4;
                // After combining: (A1+A2)x² + (B1+B2)x + (C1+C2)
                const sumA = A1 + A2, sumB = B1 + B2, sumC = C1 + C2;
                // Evaluate at x=4
                const month = 4;
                const production = sumA * month**2 + sumB * month + sumC;
            
                const qHtml = `
                  <p>
                    <strong>Scenario:</strong> Factory A makes <code>${A1}x²+${B1}x+${C1}</code> and
                    Factory B makes <code>${A2}x²+${B2}x+${C2}</code> (in hundreds of units).
                  </p>
                  <p>
                    <strong>Question:</strong>
                    <ol>
                      <li>Simplify to find the total production polynomial.</li>
                      <li>Then calculate how many hundreds of units are produced when x = ${month}.</li>
                    </ol>
                  </p>
                `;
                return {
                  q: qHtml,
                  a: [`${sumA}x² + ${sumB}x + ${sumC}`, `${production}`],
                  distract: [
                    `${sumA}x² + ${sumB}x + ${sumC + 1}`,           // wrong constant
                    `${sumA}x² + ${sumB + 1}x + ${sumC}`,           // wrong x-term
                    `${sumA}x² + ${sumB}x + ${sumC}`,               // correct poly but no eval
                  ]
                };
              }
            },
  
          // Q2) Subtract polynomials: net difference of costs
          {
            question: () => {
              const a = Math.floor(Math.random() * 3) + 2;
              const b = Math.floor(Math.random() * 5) + 1;
              const c = Math.floor(Math.random() * 3);
              const d = Math.floor(Math.random() * 3) + 1;
              const e = Math.floor(Math.random() * 5);
              const f = Math.floor(Math.random() * 3);
  
              // We'll display them as (a x² + b x + c) - (d x² + e x + f)
              // The simplified result is: (a-d) x² + (b-e) x + (c-f)
              const Q = `(${a}x² + ${b}x + ${c}) - (${d}x² + ${e}x + ${f})`;
  
              const ansA = (a - d);
              const ansB = (b - e);
              const ansC = (c - f);
  
              // We'll build a short "string expression" for the answer:
              let finalExpr = "";
              if (ansA !== 0) finalExpr += `${ansA}x²`;
              if (ansB !== 0) {
                if (finalExpr) finalExpr += ansB > 0 ? ` + ${ansB}x` : ` - ${Math.abs(ansB)}x`;
                else finalExpr += `${ansB}x`;
              }
              if (finalExpr) {
                // add constant with sign
                finalExpr += ansC >= 0 ? ` + ${ansC}` : ` - ${Math.abs(ansC)}`;
              } else {
                // if the first two were zero, just the constant
                finalExpr = String(ansC);
              }
  
              const qHtml = `
                <p><strong>Scenario:</strong> The difference between two polynomial costs is
                represented by subtracting one polynomial from another:
                <code>${Q}</code>.</p>
                <p><strong>Question:</strong> What is the simplified result after combining like
                terms? Show each like term’s subtraction.</p>
              `;
              return {
                q: qHtml,
                a: finalExpr.trim(),
                distract: [
                  `${a + d}x² + ${b + e}x + ${c + f}`,
                  `${a - d}x² - ${b - e}x + ${c - f}`
                ]
              };
            }
          },
  
          // Q3) Multiply binomials: area of rectangle
          {
            question: () => {
              // (px + q)(rx + s)
              const p = Math.floor(Math.random() * 5) + 1;
              const q = Math.floor(Math.random() * 5);
              const r = Math.floor(Math.random() * 5) + 1;
              const s = Math.floor(Math.random() * 5);
  
              // pr x² + (ps + qr)x + qs
              const pr = p * r;
              const psPlusQr = p * s + q * r;
              const qs = q * s;
  
              const qHtml = `
                <p><strong>Scenario:</strong> A rectangle’s dimensions in meters can be represented
                as <code>(${p}x + ${q})</code> and <code>(${r}x + ${s})</code>. Think of x as a scale
                factor. The area is found by multiplying these expressions.</p>
                <p><strong>Question:</strong> Expand (multiply) the binomials to get a single
                polynomial.</p>
              `;
              return {
                q: qHtml,
                a: `${pr}x² + ${psPlusQr}x + ${qs}`,
                distract: [
                  `${pr}x² + ${p*s}x + ${q*r}x + ${qs}`,
                  `${(p+s)}x² + ${pr}x + ${qs}`
                ]
              };
            }
          },
  
          // Q4) Distribute monomial: total cost with markup
          {
            question: () => {
              // a x(bx + c)
              const a = Math.floor(Math.random() * 4) + 2;
              const b = Math.floor(Math.random() * 4) + 1;
              const c = Math.floor(Math.random() * 4) + 1;
              const ans = `${a * b}x² + ${a * c}x`;
  
              const qHtml = `
                <p><strong>Scenario:</strong> A store charges a <code>${a}x</code> markup on each
                item, which originally costs <code>(${b}x + ${c})</code>. The total cost for each
                item is the product of <code>${a}x</code> and <code>(${b}x + ${c})</code>.</p>
                <p><strong>Question:</strong> Expand the expression <code>${a}x(${b}x + ${c})</code>
                to find the final form of the cost.</p>
              `;
              return {
                q: qHtml,
                a: ans,
                distract: [
                  `${a * b}x + ${a * c}`,
                  `${a + b}x² + ${c}x`
                ]
              };
            }
          },
  
          // Q5) Combine like terms: total polynomial from multiple sources
          {
            question: () => {
              // (A x² + B x + C) + (D x² + E x + F)
              const A = Math.floor(Math.random() * 5) + 1;
              const B = Math.floor(Math.random() * 5) + 1;
              const C = Math.floor(Math.random() * 5);
              const D = Math.floor(Math.random() * 5) + 1;
              const E = Math.floor(Math.random() * 5);
              const F = Math.floor(Math.random() * 5) + 1;
  
              const newA = A + D;
              const newB = B + E;
              const newC = C + F;
  
              const qHtml = `
                <p><strong>Scenario:</strong> Two polynomial expressions represent production
                in separate factories:
                <code>(${A}x² + ${B}x + ${C})</code> and
                <code>(${D}x² + ${E}x + ${F})</code>.</p>
                <p><strong>Question:</strong> Combine (add) them to get the total production
                expression. Simplify your final polynomial by combining like terms.</p>
              `;
              return {
                q: qHtml,
                a: `${newA}x² + ${newB}x + ${newC}`,
                distract: [
                  `${newA}x² + ${newB}x - ${newC}`,
                  `${(newA * 2)}x² + ${newB}x + ${newC}`
                ]
              };
            }
          }
        ];
  
      /* -----------------------------------------------------------
         3) Polynomial Factoring
      ----------------------------------------------------------- */
      case "polynomialFactoring":
        return [
          // Q1) GCF factoring scenario
          // inside getQuestionPool("polynomialFactoring"):
  
  {
      question: () => {
        // 1) generate a random linear expression
        const coefX = Math.floor(Math.random() * 5) + 2;  // 2..6
        const coefC = Math.floor(Math.random() * 5) + 2;  // 2..6
        const expr   = `${coefX}x + ${coefC}`;
    
        // 2) compute the true GCF
        const g      = gcd(coefX, coefC);
        const innerX = coefX / g;
        const innerC = coefC / g;
    
        // 3) build your HTML prompt
        const qHtml = `
          <p><strong>Scenario:</strong> A polynomial <code>${expr}</code> represents combined revenue.  
          All terms share a common factor.</p>
          <p><strong>Question:</strong> Factor out the greatest common factor (GCF) completely  
          from <code>${expr}</code>. Explain your steps.</p>
        `.trim();
    
        return {
          q: qHtml,
          a: `${g}(${innerX === 1 ? "" : innerX}x + ${innerC})`,        // e.g. "4(x+1)"
          distract: [
            `1(${coefX}x + ${coefC})`,             // never factor anything out
            `${g}(${innerX}x + ${coefC})`           // factor only the first term
          ]
        };
      }
    },
  
          // Q2) Factor x² + bx + c: yard area scenario
          {
            question: () => {
              // choose among easy factorable forms
              const picks = [
                { b: 5, c: 6, factors: "(x+2)(x+3)" },
                { b: 7, c: 10, factors: "(x+2)(x+5)" },
                { b: 6, c: 8, factors: "(x+2)(x+4)" },
                { b: 9, c: 20, factors: "(x+4)(x+5)" },
                { b: 4, c: 3, factors: "(x+1)(x+3)" }
              ];
              const choice = picks[Math.floor(Math.random() * picks.length)];
  
              const qHtml = `
                <p><strong>Scenario:</strong> The quadratic <code>x² + ${choice.b}x + ${choice.c}</code>
                represents an area (in m²) of a rectangular yard, where the length and width differ by
                integer amounts. Factoring the expression helps find possible length & width.</p>
                <p><strong>Question:</strong> Factor <code>x² + ${choice.b}x + ${choice.c}</code>
                into two binomials.</p>
              `;
              return {
                q: qHtml,
                a: choice.factors,
                distract: [
                  `(x−${choice.b})(x−${choice.c})`,
                  `(x+1)(x+${choice.b + choice.c - 1})`
                ]
              };
            }
          },
  
          // Q3) Factor ax² + bx + c with a≠1: area scenario
          {
            question: () => {
              const examples = [
                  { eq: "2x² + 7x + 3", fac: "(2x+1)(x+3)" },
                  { eq: "3x² + 4x + 1", fac: "(3x+1)(x+1)" },
                  { eq: "2x² + 5x + 2", fac: "(2x+1)(x+2)" },
                  { eq: "3x² + 5x + 2", fac: "(3x+2)(x+1)" },
                  { eq: "2x² + 9x + 4", fac: "(2x+1)(x+4)" },
                  { eq: "4x² + 13x + 3", fac: "(4x+1)(x+3)" },
                  { eq: "5x² + 11x + 2", fac: "(5x+1)(x+2)" },
                  { eq: "6x² + 11x + 3", fac: "(3x+1)(2x+3)" },
                  { eq: "3x² + 10x + 3", fac: "(3x+1)(x+3)" },
                  { eq: "2x² + 3x + 1", fac: "(2x+1)(x+1)" }
                ];
                ;
              const e = examples[Math.floor(Math.random() * examples.length)];
  
              const qHtml = `
                <p><strong>Scenario:</strong> The polynomial <code>${e.eq}</code> represents the area
                of a garden in terms of x. This time, the leading coefficient is not 1, so factoring
                is slightly more involved.</p>
                <p><strong>Question:</strong> Factor <code>${e.eq}</code> into two binomials. Show how
                you used decomposition or trial-and-error to find the correct factors.</p>
              `;
              return {
                q: qHtml,
                a: e.fac,
                distract: [
                  "(x+1)(x+3)",
                  "(2x+2)(x+1)"
                ]
              };
            }
          },
  
          // Q4) Difference of squares: box dimension scenario
          {
            question: () => {
              const picks = [
                  { expr: "x² - 9", fac: "(x+3)(x-3)" },
                  { expr: "4x² - 25", fac: "(2x+5)(2x-5)" },
                  { expr: "9x² - 16", fac: "(3x+4)(3x-4)" },
                  { expr: "x² - 49", fac: "(x+7)(x-7)" },
                  { expr: "16x² - 1", fac: "(4x+1)(4x-1)" },
                  { expr: "25x² - 36", fac: "(5x+6)(5x-6)" },
                  { expr: "36x² - 49", fac: "(6x+7)(6x-7)" },
                  { expr: "49x² - 64", fac: "(7x+8)(7x-8)" },
                  { expr: "64x² - 81", fac: "(8x+9)(8x-9)" },
                  { expr: "100x² - 1", fac: "(10x+1)(10x-1)" }
              ];
              const p = picks[Math.floor(Math.random() * picks.length)];
  
              const qHtml = `
                <p><strong>Scenario:</strong> The expression <code>${p.expr}</code> arises when
                subtracting two squared dimensions in a box design. Recognizing a difference of squares
                helps factor it quickly.</p>
                <p><strong>Question:</strong> Factor <code>${p.expr}</code>. </p>
              `;
              return {
                q: qHtml,
                a: p.fac,
                distract: [
                  `${p.fac.replace('+','-')}`,
                  `${p.fac.replace('(','(x^2+')}`
                ]
              };
            }
          },
  
          // Q5) GCF + simple factor: factoring an area formula
          {
            question: () => {
              const a = Math.floor(Math.random() * 3) + 2; // 2..4
              const b = Math.floor(Math.random() * 3) + 2; // 2..4
              // expression => a x² + a*b x
              const expr = `${a}x² + ${a*b}x`;
  
              const qHtml = `
                <p><strong>Scenario:</strong> A shape's area is given by <code>${expr}</code>. Factor
                out the greatest common factor first, then see if the remaining polynomial factors
                further if possible.</p>
                <p><strong>Question:</strong> Completely factor <code>${expr}</code>.</p>
              `;
              return {
                q: qHtml,
                a: `${a}x(x + ${b})`,
                distract: [
                  `${a}(x² + ${b}x)`,
                  `${b}x(x + ${a})`
                ]
              };
            }
          }
        ];
  
  
      /* -----------------------------------------------------------
         4) Relations & Functions
      ----------------------------------------------------------- */
      case "relationsFunctions":
        return [
          // Q1) Function or Not: map scenario
          {
            question: () => {
              // 50% chance function or not
              const isFunc = Math.random() < 0.5;
              if (isFunc) {
                const qHtml = `
                  <p><strong>Scenario:</strong> A set of points: {(1, 2), (2, 4), (3, 6)} 
                  represents hours (x) vs. distance traveled (y).</p>
                  <p><strong>Question:</strong> Is this a function? Why or why not?</p>
                `;
                return {
                  q: qHtml,
                  a: "Yes, each x has exactly one y",
                  distract: [
                    "No, it fails the vertical line test",
                    "No, x=1 repeats with different y"
                  ]
                };
              } else {
                const qHtml = `
                  <p><strong>Scenario:</strong> A set of points: {(1,2), (1,3), (2,5)}
                  is given as times (x) vs. temperature (y).</p>
                  <p><strong>Question:</strong> Is this a function? Why or why not?</p>
                `;
                return {
                  q: qHtml,
                  a: "No, x=1 has two different y-values",
                  distract: [
                    "Yes, it passes the vertical line test",
                    "Yes, there's no repeated x"
                  ]
                };
              }
            }
          },
  
          // Q2) Vertical line test: graph scenario
          {
            question: () => {
              const qHtml = `
                <p><strong>Scenario:</strong> You have a graph of points on a coordinate plane
                that represents "student ID" on the x-axis vs. "their assigned locker" on the y-axis.</p>
                <p><strong>Question:</strong> What does the vertical line test check to confirm
                it's a function? (Briefly explain the rule.)</p>
              `;
              return {
                q: qHtml,
                a: "Any vertical line should intersect at most once; if it hits more than once, not a function.",
                distract: [
                  "A function must stay above the x-axis",
                  "A function can’t have horizontal lines"
                ]
              };
            }
          },
  
          // Q3) Domain & range from scenario
          // old Q3 “Domain & range from scenario” replaced with corrected domain question
          {
              question: () => {
                const qHtml = `
                  <p><strong>Scenario:</strong> A function records a baby’s weight
                  at each month starting at birth (month 0) up to 12 months old,
                  storing data as points (month, weight).</p>
                  <p><strong>Question:</strong> What is the domain of this function?
                  Is it discrete or continuous, and why?</p>
                `;
                return {
                  q: qHtml,
                  a: "All integer months from 0 to 12 inclusive; discrete monthly measurements.",
                  distract: [
                    "All real numbers from 0 to 12 (continuous)",
                    "Integers from 1 to 12 inclusive; month 0 excluded"
                  ]
                };
              }
            },
        
            // Variant B: Temperature readings every hour
            {
              question: () => {
                const qHtml = `
                  <p><strong>Scenario:</strong> A weather station logs the
                  temperature once every hour for a 24‑hour period, as
                  points (hour, temperature).</p>
                  <p><strong>Question:</strong> What is the domain of this
                  temperature function? Discrete or continuous?</p>
                `;
                return {
                  q: qHtml,
                  a: "All integer hours from 0 to 23 inclusive; discrete hourly readings.",
                  distract: [
                    "All real numbers from 0 to 23 (continuous)",
                    "All integers from 1 to 24 inclusive"
                  ]
                };
              }
            },
        
            // Variant C: Car trip mile markers
            {
              question: () => {
                const qHtml = `
                  <p><strong>Scenario:</strong> A car’s odometer is recorded
                  at each mile marker along a 100‑mile trip, as points
                  (mile, odometer reading).</p>
                  <p><strong>Question:</strong> What is the domain of this
                  odometer function? Is it discrete or continuous?</p>
                `;
                return {
                  q: qHtml,
                  a: "All integer mile markers from 0 to 100 inclusive; discrete one‑mile increments.",
                  distract: [
                    "All real numbers from 0 to 100 (continuous)",
                    "Integers from 1 to 100 inclusive"
                  ]
                };
              }
            },
    
  
          // Q4) Evaluate function notation: price & quantity
          {
            question: () => {
              const a = Math.floor(Math.random() * 5) + 1; // slope
              const b = Math.floor(Math.random() * 5) + 1; // intercept
              const xVal = Math.floor(Math.random() * 5) + 1; 
              const val = a * xVal + b; 
  
              const qHtml = `
                <p><strong>Scenario:</strong> A linear function 
                <code>f(x) = ${a}x + ${b}</code> gives total cost (in $) if you buy x items,
                with a base fee of ${b} and each item adding $${a}.</p>
                <p><strong>Question:</strong> What is <code>f(${xVal})</code>, i.e. how much if you
                buy ${xVal} items? Evaluate the function notation properly.</p>
              `;
              return {
                q: qHtml,
                a: `$${val}`,
                distract: [
                  `$${val + 1}`,
                  `$${a + b}`
                ]
              };
            }
          },
  
          // Q5) Range from discrete relation
          {
              question: () => {
                // length between 3 and 5
                const n = Math.floor(Math.random() * 3) + 3;
                // generate points (0,y0), (1,y1), … with yi between 2 and 10
                const points = Array.from({ length: n }, (_, i) => {
                  const y = Math.floor(Math.random() * 9) + 2;
                  return `(${i}, ${y})`;
                }).join(", ");
                // extract y-values
                const ys = Array.from({ length: n }, (_, i) =>
                  points.match(/\((\d+), (\d+)\)/g)[i].replace(/.*,\s(\d+)\)/, "$1")
                );
                const correct = `{${ys.join(", ")}}`;
        
                const qHtml = `
                  <p><strong>Scenario:</strong> A function is defined by the discrete points:
                  {${points}}.</p>
                  <p><strong>Question:</strong> What is the <em>range</em> of this function
                  (the set of possible y‐values)?</p>
                `;
                return {
                  q: qHtml,
                  a: correct,
                  distract: [
                    // x‐values instead
                    `{${Array.from({length: n}, (_,i)=>i).join(", ")}}`,
                    // continuous interpretation
                    `All real numbers between ${Math.min(...ys)} and ${Math.max(...ys)}`
                  ]
                };
              }
            },
        
            // 5b) Non‑consecutive x but still discrete
            {
              question: () => {
                // pick 3 random distinct x from 0..6
                const xs = [];
                while (xs.length < 3) {
                  const candidate = Math.floor(Math.random() * 7);
                  if (!xs.includes(candidate)) xs.push(candidate);
                }
                xs.sort((a,b)=>a-b);
                // random y for each
                const points = xs
                  .map(x => `(${x}, ${Math.floor(Math.random() * 11) + 1})`)
                  .join(", ");
                const ys = points.match(/\((\d+), (\d+)\)/g).map(str =>
                  str.replace(/.*,\s(\d+)\)/, "$1")
                );
                const correct = `{${ys.join(", ")}}`;
        
                const qHtml = `
                  <p><strong>Scenario:</strong> A relation is given by the points:
                  {${points}}.</p>
                  <p><strong>Question:</strong> Identify the <em>range</em> of this relation.</p>
                `;
                return {
                  q: qHtml,
                  a: correct,
                  distract: [
                    // trick: domain
                    `{${xs.join(", ")}}`,
                    // outside values
                    `{${ys.map(y => Number(y) + 1).join(", ")}}`
                  ]
                };
              }
            },
        
            // 5c) Larger spread, to emphasize discrete vs continuous
            {
              question: () => {
                // generate 4 points with x=1,2,3,4 and y random 0..4
                const points = [1, 2, 3, 4]
                  .map(x => `(${x}, ${Math.floor(Math.random() * 5)})`)
                  .join(", ");
                const ys = points.match(/\((\d+), (\d+)\)/g).map(str =>
                  str.replace(/.*,\s(\d+)\)/, "$1")
                );
                const correct = `{${ys.join(", ")}}`;
        
                const qHtml = `
                  <p><strong>Scenario:</strong> You record a sensor’s reading at 4 time points:
                  {${points}}.</p>
                  <p><strong>Question:</strong> What is the <em>range</em> of the sensor readings?
                  Is it discrete or continuous?</p>
                `;
                return {
                  q: qHtml,
                  a: correct,
                  distract: [
                    // answer as continuous interval
                    `All real y between ${Math.min(...ys)} and ${Math.max(...ys)}`,
                    // answer as domain by mistake
                    `{1, 2, 3, 4}`
                  ]
                };
              }
            }
        ];
  
  
      /* -----------------------------------------------------------
         5) Linear Functions
      ----------------------------------------------------------- */
      case "linearFunctions":
        return [
          // Q1) Slope from two points: track speed
          {
            question: () => {
              const x1 = Math.floor(Math.random() * 5); // 0..4
              const y1 = Math.floor(Math.random() * 5);
              const x2 = x1 + 1 + Math.floor(Math.random() * 3); // ensure x2>x1
              const y2 = y1 + 1 + Math.floor(Math.random() * 3); // ensure y2>y1
              const slope = (y2 - y1) / (x2 - x1);
  
              const qHtml = `
                <p><strong>Scenario:</strong> A runner’s position at time 
                t=${x1} is y=${y1}, and at time t=${x2} is y=${y2} (all in km & hours).</p>
                <p><strong>Question:</strong> Calculate the slope (speed in km/h). Explain how you
                use slope = (difference in y)/(difference in x).</p>
              `;
              return {
                q: qHtml,
                a: String(slope),
                distract: [
                  String(-slope),
                  String(slope + 1)
                ]
              };
            }
          },
  
          // Q2) Slope–Intercept form: phone plan cost
          {
            question: () => {
              const m = Math.floor(Math.random() * 4) + 1; // monthly cost per unit
              const b = Math.floor(Math.random() * 5) + 5; // base fee 5..9
              const qHtml = `
                <p><strong>Scenario:</strong> A phone plan charges a base fee of $${b}, plus
                $${m} per gigabyte of data used. The total cost y (in $) is a linear function of
                x (the number of gigabytes).</p>
                <p><strong>Question:</strong> Write this relationship in slope–intercept form,
                y = mx + b.</p>
              `;
              return {
                q: qHtml,
                a: `y=${m}x+${b}`,
                distract: [
                  `y=${b}x+${m}`,
                  `x=${m}y+${b}`
                ]
              };
            }
          },
  
          // Q3) Interpret the intercept: garden bed problem
          {
            question: () => {
              const intercept = Math.floor(Math.random() * 4) + 2; 
              const slope = Math.floor(Math.random() * 3) + 1; 
              const qHtml = `
                <p><strong>Scenario:</strong> A garden bed’s depth can be modeled by 
                <code>y = ${slope}x + ${intercept}</code>, where x is distance (m) from one end,
                and y is the soil depth (cm). The intercept is at x=0.</p>
                <p><strong>Question:</strong> What does the intercept of <code>${intercept}</code>
                represent in this context?</p>
              `;
              return {
                q: qHtml,
                a: `It’s the initial soil depth (when x=0).`,
                distract: [
                  `It’s the slope or rate of change in depth.`,
                  `It means there’s no soil at x=0.`
                ]
              };
            }
          },
  
          // Q4) Parallel lines: road marking
          {
            question: () => {
              const m = Math.floor(Math.random() * 3) + 1;
              const qHtml = `
                <p><strong>Scenario:</strong> Road paint lines are parallel if they have the same
                slope. Suppose one line is <code>y=${m}x+2</code>.</p>
                <p><strong>Question:</strong> Which of the following lines is parallel to that
                line?</p>
              `;
              return {
                q: qHtml,
                a: `y=${m}x−5`,
                distract: [
                  `y=${-1/m}x+1`,
                  `y=${m+1}x+2`
                ]
              };
            }
          },
  
          // Q5) Perpendicular lines: crossing paths
          // Linear Functions → Perpendicular lines (more variety)
          {
              question: () => {
                const m = 1; // slope of the given line y = 1x + 4
                // Two valid perpendicular intercepts we might use
                const possibleIntercepts = [1, 5];
                // randomly pick one to be the “correct” perpendicular line
                const correctB = possibleIntercepts[
                  Math.floor(Math.random() * possibleIntercepts.length)
                ];
                // and use the other as a distractor
                const otherB = possibleIntercepts.find(b => b !== correctB);
            
                const qHtml = `
                  <p><strong>Scenario:</strong> Two crosswalk lines are perpendicular if their slopes
                  are negative reciprocals. One line is <code>y = ${m}x + 4</code>.</p>
                  <p><strong>Question:</strong> Which of the following is perpendicular to it?</p>
                `;
            
                return {
                  q: qHtml,
                  // single correct choice
                  a: `y = -${m}x + ${correctB}`,
                  distract: [
                    `y = ${m}x + ${correctB}`,          // same slope → not perpendicular
                    `y = -${m}x + ${otherB}`,            // also slope -1 but we treat it as a "trap"
                    `y = ${-1/m}x + ${4}`                // wrong intercept identical to original
                  ]
                };
              }
            }
        ];
  
  
      /* -----------------------------------------------------------
         6) Arithmetic Sequences
      ----------------------------------------------------------- */
      case "arithmeticSequences":
        return [
          // Q1) Common difference: basic scenario
          {
            question: () => {
              // We'll pick a short sequence with difference d
              const d = Math.floor(Math.random() * 4) + 2; // 2..5
              const start = Math.floor(Math.random() * 5) + 1; // 1..5
              // sequence: start, start+d, start+2d, ...
              const a2 = start + d;
              const a3 = start + 2*d;
              const a4 = start + 3*d;
              const seqStr = `${start}, ${a2}, ${a3}, ${a4}`;
              
              const qHtml = `
                <p><strong>Scenario:</strong> A sequence of daily tasks completed is 
                ${seqStr}, ... Each day you do the same additional number of tasks as the previous day.</p>
                <p><strong>Question:</strong> What is the common difference "d" in this arithmetic
                sequence? Explain how you see it from consecutive terms.</p>
              `;
              return {
                q: qHtml,
                a: String(d),
                distract: [String(d + 1), String(d - 1 > 0 ? d - 1 : d + 2)]
              };
            }
          },
  
          // Q2) Next term scenario
          {
            question: () => {
              const start = Math.floor(Math.random() * 5) + 2; 
              const diff = Math.floor(Math.random() * 4) + 1;
              const second = start + diff;
              const third = second + diff;
              const nextTerm = third + diff;
              const qHtml = `
                <p><strong>Scenario:</strong> A snail moves along a line. Each hour, it moves
                ${diff} cm more than the previous hour. The first three hours’ distances are
                ${start} cm, ${second} cm, and ${third} cm.</p>
                <p><strong>Question:</strong> What is the distance traveled in the 4th hour, i.e.
                the next term of the sequence?</p>
              `;
              return {
                q: qHtml,
                a: String(nextTerm),
                distract: [
                  String(nextTerm + 1),
                  String(nextTerm - 1)
                ]
              };
            }
          },
  
          // Q3) nth term formula scenario
          {
            question: () => {
              const qHtml = `
                <p><strong>Scenario:</strong> In an arithmetic pattern, the nth term is given
                by a formula involving the first term a and the common difference d.</p>
                <p><strong>Question:</strong> Which formula correctly describes the nth term
                of an arithmetic sequence in general?</p>
              `;
              return {
                q: qHtml,
                a: "tₙ = a + (n−1)d",
                distract: [
                  "tₙ = a · dⁿ",
                  "tₙ = a² + d"
                ]
              };
            }
          },
  
          // Q4) Find the 10th term scenario
          {
            question: () => {
              const a = Math.floor(Math.random() * 5) + 1;
              const d = Math.floor(Math.random() * 5) + 1;
              const t10 = a + (10 - 1) * d;
              const qHtml = `
                <p><strong>Scenario:</strong> An arithmetic sequence starts at 
                <strong>${a}</strong> and increases by <strong>${d}</strong> each step.</p>
                <p><strong>Question:</strong> What is the 10th term (t₁₀) of this sequence?
                Explain your method briefly.</p>
              `;
              return {
                q: qHtml,
                a: String(t10),
                distract: [String(t10 + 1), String(Math.max(0, t10 - 2))]
              };
            }
          },
  
          // Q5) Real-life scenario: monthly saving
          {
            question: () => {
              const start = Math.floor(Math.random() * 50) + 50; // 50..99
              const diff = Math.floor(Math.random() * 20) + 10;  // 10..29
              const qHtml = `
                <p><strong>Scenario:</strong> You save $${start} in the first month, then each
                month you save $${diff} more than the previous month, forming an arithmetic sequence
                of monthly savings.</p>
                <p><strong>Question:</strong> Write a brief expression or formula for the nth month's
                saving. (You may use tₙ = ? or a + (n−1)d style.)</p>
              `;
              return {
                q: qHtml,
                a: `tₙ = ${start} + (n−1)*${diff}`,
                distract: [
                  `tₙ = ${diff} · (n−1) - ${start}`,
                  `tₙ = ${start}+${diff}ᵑ`
                ]
              };
            }
          }
        ];
  
  
      /* -----------------------------------------------------------
         7) Systems of Linear Equations
      ----------------------------------------------------------- */
      case "systemsLinearEq":
    return [
      // 1) Substitution #1: ticket pricing
      {
        question: () => {
          const qHtml = `
            <p><strong>Scenario:</strong> Adult movie tickets (x) cost $3 more
            than student tickets (y). 2 adult + 4 student tickets cost $50.</p>
            <p><strong>System:</strong>
              <br/> x = y + 3
              <br/> 2x + 4y = 50
            </p>
            <p><strong>Question:</strong> Use substitution to find x and y.</p>
          `;
          return {
            q: qHtml,
            a: "(x=11, y=8)",
            distract: ["(x=8, y=11)", "(x=10, y=7)"]
          };
        }
      },
  
      // 2) Substitution #2: phone plans
      {
        question: () => {
          const qHtml = `
            <p><strong>Scenario:</strong> A family plan (x) is $5 more than
            the individual plan (y). Together, one family + two individual plans
            total $95.</p>
            <p><strong>System:</strong>
              <br/> x = y + 5
              <br/> x + 2y = 95
            </p>
            <p><strong>Question:</strong> Find x and y by substitution.</p>
          `;
          return {
            q: qHtml,
            a: "(x=35, y=30)",
            distract: ["(x=30, y=25)", "(x=40, y=35)"]
          };
        }
      },
  
      // 3) Elimination #1: café purchases
      {
        question: () => {
          const qHtml = `
            <p><strong>Scenario:</strong> A latte (x) and a muffin (y)
            cost $12 together if you buy 1 latte + 2 muffins. 2 lattes + 3 muffins
            cost $27.</p>
            <p><strong>System:</strong>
              <br/> x + 2y = 12
              <br/> 2x + 3y = 27
            </p>
            <p><strong>Question:</strong> Use elimination to find each price.</p>
          `;
          return {
            q: qHtml,
            a: "(x=9, y=1.5)",
            distract: ["(x=3, y=4.5)", "No solution"]
          };
        }
      },
  
      // 4) Elimination #2: stationery
      {
        question: () => {
          const qHtml = `
            <p><strong>Scenario:</strong> 3 pencils + 4 erasers cost $7.
            5 pencils + 2 erasers cost $9.</p>
            <p><strong>System:</strong>
              <br/> 3x + 4y = 7
              <br/> 5x + 2y = 9
            </p>
            <p><strong>Question:</strong> Eliminate to solve for x (pencils) & y (erasers).</p>
          `;
          return {
            q: qHtml,
            a: "(x=1, y=1)",
            distract: ["(x=0.5, y=1.25)", "Infinite solutions"]
          };
        }
      },
  
      // 5) Parallel #1: gym membership
      {
        question: () => {
          const qHtml = `
            <p><strong>Scenario:</strong> Two gym plans:
              <code>y = 20x + 100</code> and <code>y = 20x + 150</code>.</p>
            <p><strong>Question:</strong> How many solutions does the system have?
            Why?</p>
          `;
          return {
            q: qHtml,
            a: "No solution (parallel lines)",
            distract: ["Exactly one", "Infinitely many"]
          };
        }
      },
  
      // 6) Parallel #2: tuition schedules
      {
        question: () => {
          const qHtml = `
            <p><strong>Scenario:</strong> Two boarding schools charge:
              <code>y = 30x + 200</code> vs. <code>y = 30x + 300</code>.</p>
            <p><strong>Question:</strong> Does the pair intersect?
            Explain in context.</p>
          `;
          return {
            q: qHtml,
            a: "No intersection (no solution)",
            distract: ["One intersection", "All points intersect"]
          };
        }
      },
  
      // 7) Word‐problem #1: fruit market
      {
        question: () => {
          const qHtml = `
            <p><strong>Scenario:</strong> 3 apples + 2 oranges = $11.
            2 apples + 2 oranges = $8.</p>
            <p><strong>Question:</strong> Set up and solve the system
            for apple (x) & orange (y).</p>
          `;
          return {
            q: qHtml,
            a: "Apple=$3, Orange=$1",
            distract: ["Apple=$2, Orange=$3", "No unique solution"]
          };
        }
      },
  
      // 8) Word‐problem #2: chemical mixture
      {
        question: () => {
          const qHtml = `
            <p><strong>Scenario:</strong> 2 L of solution A + 3 L of B
            cost $50. 1 L of A + 4 L of B cost $55.</p>
            <p><strong>Question:</strong> Solve for price per litre of A (x)
            and B (y).</p>
          `;
          return {
            q: qHtml,
            a: "(x=20, y=5)",
            distract: ["(x=5, y=20)", "No solution"]
          };
        }
      },
  
      // 9) Infinite #1: same line
      {
        question: () => {
          const qHtml = `
            <p><strong>Scenario:</strong> You have:
              <code>3x + 2y = 12</code> and <code>6x + 4y = 24</code>.</p>
            <p><strong>Question:</strong> How many solutions? Explain.</p>
          `;
          return {
            q: qHtml,
            a: "Infinitely many (same line)",
            distract: ["One solution", "None"]
          };
        }
      },
  
      // 10) Infinite #2: scalar multiple
      {
        question: () => {
          const qHtml = `
            <p><strong>Scenario:</strong> Equations:
              <code>5x - y = 10</code> and <code>10x - 2y = 20</code>.</p>
            <p><strong>Question:</strong> Determine number of solutions.</p>
          `;
          return {
            q: qHtml,
            a: "Infinitely many (identical lines)",
            distract: ["Exactly one", "No solution"]
          };
        }
      }
    ];
  
  
      /* -----------------------------------------------------------
         8) Right Triangle Trigonometry
      ----------------------------------------------------------- */
      case "rightTriangleTrig":
        return [
          // Q1) Identify hypotenuse: ladder problem
          {
            question: () => {
              const qHtml = `
                <p><strong>Scenario:</strong> You have a right triangle formed by a wall,
                the ground, and a ladder leaning against the wall. The angle is at the ground.</p>
                <p><strong>Question:</strong> Which side is the hypotenuse in any right triangle?
                (In the ladder example, it’s clearly which side?)</p>
              `;
              return {
                q: qHtml,
                a: "The longest side opposite the right angle (the ladder).",
                distract: [
                  "One of the legs on the ground",
                  "Any side we choose"
                ]
              };
            }
          },
  
          // Q2) Use sin to find missing side: ramp
          {
            question: () => {
              const qHtml = `
                <p><strong>Scenario:</strong> A wheelchair ramp forms a 30° angle with the ground,
                and the ramp’s length (hypotenuse) is 10 m.</p>
                <p><strong>Question:</strong> Using 
                <code>sin(30°) = opposite / 10</code>, find the height of the ramp at its end.
                (Explain your trig step briefly.)</p>
              `;
              return {
                q: qHtml,
                a: "5 m",
                distract: ["10 m","5√2 m"]
              };
            }
          },
  
          // Q3) Use tan to find angle: slope of a hill
          {
              question: () => {
                // Q1a: Original “3m rise over 4m run”
                const opp = 3;
                const adj = 4;
                const ratio = (opp / adj).toFixed(2); // => 0.75
                const angleApprox = "36.9°";
            
                const qHtml = `
                  <h3>Q1a: Hillside Slope</h3>
                  <p>
                    <strong>Scenario:</strong> A hillside rises 3&nbsp;m vertically for every 
                    4&nbsp;m horizontally. That means 
                    <code>tan(θ) = 3/4</code> = ${ratio}.
                  </p>
                  <div style="margin: 1em 0; border: 1px solid #ccc; width: 400px; max-width: 100%;">
                    <svg 
                      width="400" 
                      height="250" 
                      viewBox="0 0 120 80" 
                      style="background: #fff;"
                    >
                      <!-- Horizontal “run” = 4 m -->
                      <line x1="10" y1="60" x2="50" y2="60" stroke="#2e7d32" stroke-width="4" />
                      <text x="30" y="70" font-size="12" fill="#2e7d32" text-anchor="middle">4 m</text>
            
                      <!-- Vertical “rise” = 3 m -->
                      <line x1="50" y1="60" x2="50" y2="30" stroke="#c62828" stroke-width="4" />
                      <text x="52" y="45" font-size="12" fill="#c62828">3 m</text>
            
                      <!-- Slope (hypotenuse) -->
                      <line x1="10" y1="60" x2="50" y2="30" stroke="#1976d2" stroke-width="4" />
            
                      <!-- Angle arc -->
                      <path d="M14,60 A12,12 0 0,1 24,50" fill="none" stroke="#000" stroke-width="1.5" />
                      <text x="18" y="56" font-size="14" font-weight="bold">θ</text>
                    </svg>
                  </div>
                  <p>
                    <strong>Question:</strong> Approximately what is the angle <code>θ</code>
                    of the hill’s slope? (Use <code>tan⁻¹(0.75)</code>.)
                  </p>
                `;
                return {
                  q: qHtml,
                  a: angleApprox,
                  distract: ["45°", "53.1°"]
                };
              }
            },
            {
              question: () => {
                // Q1b: Another slope, e.g., 5m rise / 7m run
                const opp = 5;
                const adj = 7;
                const ratio = (opp / adj).toFixed(2); // => ~0.71
                const angleApprox = "35.2°"; // e.g. (atan(0.71) ≈ 35.2°)
            
                const qHtml = `
                  <h3>Q1b: Hillside Slope</h3>
                  <p>
                    <strong>Scenario:</strong> Another hillside rises 5&nbsp;m vertically for 
                    every 7&nbsp;m horizontally. That means 
                    <code>tan(θ) = 5/7</code> ≈ ${ratio}.
                  </p>
                  <p>
                    This is slightly less steep than 3:4. 
                  </p>
                  <p>
                    <strong>Question:</strong> Approximately what is 
                    <code>θ = tan⁻¹(5/7)</code>?
                  </p>
                `;
                return {
                  q: qHtml,
                  a: angleApprox,
                  distract: ["40.0°", "28.5°"]
                };
              }
            },
            {
              question: () => {
                // Q1c: Another slope, e.g. 8m rise / 5m run
                // => tan(θ) = 8/5 = 1.60 => angle ~ 58.0°
                const opp = 8;
                const adj = 5;
                const ratio = (opp / adj).toFixed(2); // => 1.60
                const angleApprox = "58.0°";
            
                const qHtml = `
                  <h3>Q1c: Hillside Slope</h3>
                  <p>
                    <strong>Scenario:</strong> A steep hillside rises 8&nbsp;m vertically for 
                    every 5&nbsp;m horizontally. That means 
                    <code>tan(θ) = 8/5</code> = ${ratio}.
                  </p>
                  <p>
                    <strong>Question:</strong> Approximately what is 
                    <code>θ = tan⁻¹(8/5)</code>? 
                  </p>
                  <p>
                    (Hint: 8/5 = 1.6, so expect an angle significantly > 45°!)
                  </p>
                `;
                return {
                  q: qHtml,
                  a: angleApprox,
                  distract: ["32.0°", "61.5°"]
                };
              }
            },
            // ===========================================
  // Footbridge Section
  // ===========================================
  {
      title: <h1>Q4b: Footbridge Creek</h1>,
      body: (
        <>
          <p style={{ margin: "0 0 0.5em 0", lineHeight: 1.4 }}>
            <strong>Scenario:</strong> Another footbridge has a diagonal length of 12 m, 
            forming a 65° angle with the horizontal.
          </p>
          <p style={{ margin: 0, lineHeight: 1.4 }}>
            <strong>Question:</strong> How wide is the creek (the horizontal distance)? 
            Use <code>cos(65°) = adjacent/12</code>.
          </p>
        </>
      )
    },
    {
      // Q4b: Another footbridge question with new numbers
      question: () => {
        // Suppose the diagonal is 12 m at a 65° angle
        // => cos(65°) = adj/12 => adj = 12*cos(65°) => ~5.07
        const qHtml = `
          <h3>Q4b: Footbridge Creek</h3>
          <p>
            <strong>Scenario:</strong> Another footbridge has a diagonal length of 12&nbsp;m,
            forming a 65° angle with the horizontal.
          </p>
          <p>
            <strong>Question:</strong> How wide is the creek, i.e. the horizontal distance?
            Use <code>cos(65°) = adjacent / 12</code>.
          </p>
        `;
        return {
          q: qHtml,
          a: "≈5.07 m",
          distract: ["≈10.88 m", "≈2.54 m"]
        };
      }
    },
    
            // ===========================================
  // Pythagorean + Trig Check Section
  // ===========================================
  {
      question: () => {
        // Q5a: Original 6–8–? triangle
        const qHtml = `
          <h3>Q5a: Right Triangle Dimensions</h3>
          <p>
            <strong>Scenario:</strong> A right triangle has legs of 6&nbsp;m and 8&nbsp;m.
            Using the Pythagorean theorem or basic trig, find the hypotenuse length. 
            (This is a classic 3-4-5 ratio, scaled by 2.)
          </p>
          <div style="margin: 1em 0; border: 1px solid #ccc; width: 300px; max-width: 100%;">
            <svg 
              width="300"
              height="180"
              viewBox="0 0 300 180"
              style="background:#fff;"
            >
              <!-- Base (8 m) -->
              <line x1="30" y1="140" x2="230" y2="140" stroke="#2e7d32" stroke-width="4" />
              <text 
                x="130" y="155"
                font-size="12" fill="#2e7d32" text-anchor="middle"
              >
                8 m
              </text>
    
              <!-- Vertical (6 m) -->
              <line x1="230" y1="140" x2="230" y2="80" stroke="#c62828" stroke-width="4" />
              <text x="235" y="110" font-size="12" fill="#c62828">
                6 m
              </text>
    
              <!-- Hypotenuse (?) -->
              <line x1="30" y1="140" x2="230" y2="80" stroke="#1976d2" stroke-width="4" />
              <text x="140" y="100" font-size="12" fill="#1976d2">?</text>
            </svg>
          </div>
          <p><strong>Question:</strong> What is the triangle’s hypotenuse?</p>
        `;
        return {
          q: qHtml,
          a: "10 m",
          distract: ["14 m", "9 m"]
        };
      }
    },
    {
      // Q5b: Another one, e.g. 9–12–? 
      // => 3–4–5 ratio x3 => 15 is the hypotenuse
      question: () => {
        const qHtml = `
          <h3>Q5b: Right Triangle Dimensions</h3>
          <p>
            <strong>Scenario:</strong> A right triangle has legs of 9&nbsp;m and 12&nbsp;m.
            Using Pythagorean theorem or basic trig, find its hypotenuse. 
            (Hint: it's a 3–4–5 ratio times 3.)
          </p>
          <p><strong>Question:</strong> The hypotenuse = ?</p>
        `;
        return {
          q: qHtml,
          a: "15 m",
          distract: ["21 m", "10.6 m"]
        };
      }
    },
       
        ];
  
  
      /* -----------------------------------------------------------
         9) Financial Literacy
      ----------------------------------------------------------- */
      case "financialLit":
        return [
          // Q1) Gross pay from hours worked
          {
            question: () => {
              const rate = Math.floor(Math.random() * 5) + 12; // $12–$16/hr
              const hours = 8;
              const pay = rate * hours;
              const qHtml = `
                <p><strong>Scenario:</strong> A part-time job pays <strong>$${rate}</strong> per hour
                for ${hours} hours of work (no overtime).</p>
                <p><strong>Question:</strong> What is the gross pay for that day?</p>
              `;
              return {
                q: qHtml,
                a: `$${pay}`,
                distract: [`$${pay + 5}`, `$${pay - 10}`]
              };
            }
          },
  
          // Q2) Commission scenario
          {
            question: () => {
              const sales = 1000;
              const commPct = 5; // 5%
              const commission = (sales * commPct / 100).toFixed(2);
              const qHtml = `
                <p><strong>Scenario:</strong> A salesperson earns a <strong>${commPct}%</strong>
                commission on total sales of <strong>$${sales}</strong> in a week.</p>
                <p><strong>Question:</strong> Calculate the commission amount.</p>
              `;
              return {
                q: qHtml,
                a: `$${commission}`,
                distract: [
                  `$${(sales * 0.05 + 5).toFixed(2)}`,
                  `$${(sales * 0.5).toFixed(2)}`
                ]
              };
            }
          },
  
          // Q3) Basic tax deduction
          {
            question: () => {
              const gross = 1200;
              const taxPct = 20; // 20%
              const net = (gross * (1 - taxPct / 100)).toFixed(2);
              const qHtml = `
                <p><strong>Scenario:</strong> You earn <strong>$${gross}</strong> gross pay,
                and pay <strong>${taxPct}%</strong> in income tax.</p>
                <p><strong>Question:</strong> What is your net pay?</p>
              `;
              return {
                q: qHtml,
                a: `$${net}`,
                distract: ["$200", `$${gross}`]
              };
            }
          },
  
          // Q4) Overtime pay
          {
            question: () => {
              const rate = 15;      // $15/hr
              const regularHrs = 8; // 8 hrs
              const otHrs = 4;      // 4 hrs overtime
              const otRate = rate * 1.5; // time-and-a-half
              const total = rate * regularHrs + otRate * otHrs;
              const qHtml = `
                <p><strong>Scenario:</strong> An employee makes <strong>$${rate}/hr</strong>.
                They work <strong>${regularHrs} hrs</strong> at normal time and
                <strong>${otHrs} hrs</strong> overtime at time-and-a-half.</p>
                <p><strong>Question:</strong> What is their total gross pay?</p>
              `;
              return {
                q: qHtml,
                a: `$${total.toFixed(2)}`,
                distract: [
                  `$${(rate * (regularHrs + otHrs)).toFixed(2)}`,
                  `$${(otRate * (regularHrs + otHrs)).toFixed(2)}`
                ]
              };
            }
          },
  
          // Q5) Salary to hourly conversion
          {
            question: () => {
              const annual = 52000; // $52 000/year
              const payPeriods = 52; // weeks
              const weekly = annual / payPeriods;
              const hours = 40;
              const hourly = (weekly / hours).toFixed(2);
              const qHtml = `
                <p><strong>Scenario:</strong> A salaried worker earns <strong>$${annual}</strong>
                per year, paid weekly (<strong>${payPeriods}</strong> pay periods), working
                <strong>${hours} hrs</strong> each week.</p>
                <p><strong>Question:</strong> What is their equivalent hourly wage?</p>
              `;
              return {
                q: qHtml,
                a: `$${hourly}`,
                distract: [
                  `$${(annual / (payPeriods * hours) + 2).toFixed(2)}`,
                  `$${(annual / hours).toFixed(2)}`
                ]
              };
            }
          },
  
          // Q6) Piecework earnings
          {
            question: () => {
              const rate = 2;     // $2 per unit
              const units = 135;  // 135 units
              const earnings = rate * units;
              const qHtml = `
                <p><strong>Scenario:</strong> A pieceworker earns <strong>$${rate}</strong> per
                item. They produce <strong>${units}</strong> items in a day.</p>
                <p><strong>Question:</strong> What is their total pay for that day?</p>
              `;
              return {
                q: qHtml,
                a: `$${earnings}`,
                distract: [
                  `$${(earnings + 50)}`,
                  `$${(units * (rate + 1))}`
                ]
              };
            }
          },
  
          // Q7) Simple definition
          {
            question: () => {
              const qHtml = `
                <p><strong>Scenario:</strong> On your pay stub, you see "gross pay" and "net pay."</p>
                <p><strong>Question:</strong> Which statement correctly defines net pay?</p>
              `;
              return {
                q: qHtml,
                a: "Net pay = Gross pay − All deductions",
                distract: [
                  "Net pay = Gross pay + Taxes",
                  "Net pay = Hourly rate × Hours worked"
                ]
              };
            }
          },
  
          // Q8) Comparing salary vs hourly
          {
            question: () => {
              const qHtml = `
                <p><strong>Scenario:</strong> John is hourly; Sara is salaried. They compare pay
                structures.</p>
                <p><strong>Question:</strong> Which is true?</p>
              `;
              return {
                q: qHtml,
                a: "Hourly pay varies with hours; salary is fixed annually",
                distract: [
                  "Salary always exceeds hourly earnings",
                  "Hourly jobs never pay overtime"
                ]
              };
            }
          },
  
          // Q9) Simplified tax bracket
          {
            question: () => {
              const income = 30000;
              const bracket1 = 10000 * 0.10;
              const bracket2 = (income - 10000) * 0.20;
              const tax = bracket1 + bracket2;
              const net = (income - tax).toFixed(0);
              const qHtml = `
                <p><strong>Scenario:</strong> Taxes are 10 % on first $10 000, 20 % on the rest.
                Income = $${income}.</p>
                <p><strong>Question:</strong> What is net income after tax?</p>
              `;
              return {
                q: qHtml,
                a: `$${net}`,
                distract: [
                  `$${(income * 0.80).toFixed(0)}`,
                  `$${(income - income * 0.10).toFixed(0)}`
                ]
              };
            }
          },
  
          // Q10) Simple multiple choice
          {
            question: () => {
              const qHtml = `
                <p><strong>Scenario:</strong> An employee’s pay stub shows:\n
                Gross = $1200, Deductions = $240.</p>
                <p><strong>Question:</strong> What is their net pay?</p>
              `;
              return {
                q: qHtml,
                a: "$960",
                distract: ["$1440", "$1200"]
              };
            }
          }
        ];
  
      /* -----------------------------------------------------------
         Default / no topic
      ----------------------------------------------------------- */
      default:
        console.warn(`No question pool for topic "${topic}"`);
        return [];
    }
  }

export function generateQuizQuestion(forcedTopic) {
    const topics = forcedTopic
      ? [forcedTopic]
      : [
          "exponentsRadicals",
          "polynomialOperations",
          "polynomialFactoring",
          "relationsFunctions",
          "linearFunctions",
          "arithmeticSequences",
          "systemsLinearEq",
          "rightTriangleTrig",
          "financialLit"
        ];
    const chosen = topics[Math.floor(Math.random() * topics.length)];
    const pool = getQuestionPool(chosen);
    if (!pool.length) {
      return { question: "No questions available", correctAnswer: "", options: [] };
    }
    const item = pool[Math.floor(Math.random() * pool.length)];
    if (!item || typeof item.question !== "function") {
      console.error("Bad item in question pool:", item);
      return { question: "Error: Invalid question item", correctAnswer: "", options: [] };
    }
    const qObj = item.question();
    const distractors = qObj.distract || [];
  
    // build one deduped, shuffled array of options
    const allOptions = Array.from(new Set([qObj.a, ...distractors]));
    allOptions.sort(() => Math.random() - 0.5);
  
    return {
      question: qObj.q,
      correctAnswer: qObj.a,
      options: allOptions,
      visual: qObj.visual
    };
  }